module.exports = __webpack_public_path__ + "1_0_57/img/remove-section.2160eb78.svg";